import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { formatMoney, getInlineLoader } from "../Helpers";
import {
	STR_CHANGE_PHONE_NUMBER,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_DEBTS,
	STR_CHARITY,
	STR_EXPENSES,
	STR_INCOME,
	STR_INSURANCE,
	STR_INVESTMENTS,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_SAVINGS,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_VIEW_MORE,
	STR_INDIVIDUALS,
	STR_GROUPS,
	STR_REGISTERED,
	STR_REQUESTS
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdInfoOutline, MdMoney, MdOutlineMoneyOff, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup } from 'react-icons/md';
import { GiPayMoney } from "react-icons/gi";
import { TbMoneybag } from "react-icons/tb";
import { LiaMoneyCheckSolid } from "react-icons/lia";
import { GrMoney } from "react-icons/gr";
import TabbedView from '../components/TabbedView';
import RegisteredSenderIds from '../views/RegisteredSenderIds';
import RequestedSenderIds from '../views/RequestedSenderIds';

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		
		setReady(true);
	}



	useEffect(() => {
		init();
	}, [])



	if (ready) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingTop: "20px",
					paddingBottom: "20px",
				}}
				className="mNoScrollBar"
			>
			
				<TabbedView
          tabs={
            [              
              { id: 0, label: STR_REGISTERED[appContext.language], content: <RegisteredSenderIds/> },
              { id: 1, label: STR_REQUESTS[appContext.language], content: <RequestedSenderIds/> },
            ]
          }
        />

			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}